import { ReactElement } from 'react';
import { IconButton, Typography } from '@mui/material';
import { ArrowRight, ArrowLeft, Print, Download, ZoomOut, ZoomIn } from '@mui/icons-material';
import { styled } from '@mui/styles';
import printJS from 'print-js';

export type PositionValue = 'static' | 'relative' | 'absolute' | 'sticky' | 'fixed';

interface DivControlsProps {
  position?: PositionValue;
}

const DivControls = styled('div')<DivControlsProps>((props) => ({
  background: '#ffff',
  boxShadow: '1px 1px 1px 2px rgba(16, 36, 94, 0.2)',
  borderRadius: '4px',
  position: props.theme.position || 'fixed',
  zIndex: 1,
  display: 'flex',
  alignItems: 'center',
  top: '5rem',
  margin: '1rem',
  '& > span': {
    display: 'flex;',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
}));

interface ControlsProps {
  onNext: (page: number) => void;
  onBack: (page: number) => void;
  page: number;
  totalPages: number;
  file: string;
  name: string;
  downloadable?: boolean;
  printable?: boolean;
  setDimension: (width: number) => void;
  positionControls?: PositionValue;
}

export const Controls = ({
  onNext,
  onBack,
  page,
  totalPages,
  file,
  name,
  downloadable,
  printable,
  setDimension,
  positionControls,
}: ControlsProps): ReactElement => (
  <>
    <div className="pmi-d-flex pmi-m-1 pmi-justify-content-center pmi-align-items-center">
      <DivControls theme={{ position: positionControls }}>
        <IconButton disabled={page === 1} onClick={() => onBack(page - 1)}>
          <ArrowLeft />
        </IconButton>
        <Typography>
          {page} di {totalPages}
        </Typography>
        <IconButton disabled={page === totalPages} onClick={() => onNext(page + 1)}>
          <ArrowRight />
        </IconButton>
        <a
          href={`data:application/pdf;base64, ${file}`}
          download={name}
          style={{ pointerEvents: !downloadable ? 'none' : undefined }}
        >
          <IconButton disabled={!downloadable}>
            <Download />
          </IconButton>
        </a>

        <IconButton
          onClick={() => {
            printJS({
              printable: file,
              type: 'pdf',
              base64: true,
            });
          }}
          disabled={!printable}
        >
          <Print />
        </IconButton>
        <IconButton
          onClick={() => {
            setDimension(10);
          }}
        >
          <ZoomIn />
        </IconButton>
        <IconButton
          onClick={() => {
            setDimension(-10);
          }}
        >
          <ZoomOut />
        </IconButton>
      </DivControls>
    </div>
  </>
);
Controls.displayName = 'Controls pdf viewer';
